/* ============================================================================
   cl-pdp-look.js — de winkelwagenlade openen na een herlaadbeurt

   Dit bestand deed hiervoor twee dingen: het artikel in het mandje leggen als
   je op een plusje bij "Komplettiere den Look" drukte, en daarna de lade
   openen. Het eerste is weg — die knop opent nu de snelkoop-lade, zodat je
   eerst maat en kleur kiest (zie assets/cl-qa.js). Wat blijft is het tweede.

   Waarom er überhaupt een herlaadbeurt is: Stiletto bindt zijn snelkoop-knoppen
   per component, en die component draait op de productpagina niet — klikken
   deed aantoonbaar niets, het mandje bleef op nul. Er is ook geen publieke
   ingang om de lade bij te werken: `window.theme` bevat alleen instellingen en
   `cart` bestaat niet op window. Gemeten, niet aangenomen.

   Twee dingen geprobeerd en allebei verworpen:
   - de hele lade-sectie opnieuw ophalen en vervangen: de inhoud klopte, maar de
     sluitknop deed het daarna niet meer. Zijn luisteraars overleven een
     innerHTML-wissel niet, en een lade die niet meer dicht kan is erger dan een
     knop die niets doet.
   - alleen de regels in de lade vervangen: die bestaan niet als het mandje leeg
     was toen de pagina laadde, dus dan gebeurt er niets.

   Wat overblijft is de pagina verversen. Dan rendert Shopify de lade zelf, met
   de juiste inhoud en met alle luisteraars van het thema erop. De vlag in
   sessionStorage wordt gezet door cl-qa.js na een geslaagde toevoeging; dit
   bestand leest hem uit en opent de lade.
   ============================================================================ */
(function () {
  'use strict';

  var MANDJE_IN_KOP = 'header a[href$="/cart"], .header__icon-touch[href$="/cart"]';

  var VLAG = 'cl-pdp-look-open';

  function open() {
    var knop = document.querySelector(MANDJE_IN_KOP);
    if (knop) knop.click();
  }

  // Na de herlaadbeurt de lade openen. Meteen proberen en anders nog één keer
  // wachten: de kop is een eigen sectie en kan een tel later klaar zijn.
  function na_herladen() {
    try {
      if (sessionStorage.getItem(VLAG) !== '1') return;
      sessionStorage.removeItem(VLAG);
    } catch (e) { return; }
    if (document.querySelector(MANDJE_IN_KOP)) open();
    else setTimeout(open, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', na_herladen);
  else na_herladen();

})();
